import { AnomaliesInfo } from "./types"

export const infoMapper: Record<string, AnomaliesInfo> = {
    alert: {
      title: "Alert notification",
      icon: "notification_important",
      color: "danger",
      description:"Get more space"
    },
    warning: {
      title: "Warning notification",
      icon: "priority_high",
      color: "warning",
      description:"Get more space"
    },
    control: {
      title: "Control notification",
      icon: "notifications_active",
      color: "info",
      description:"Get more space"
    },
    info: {
      title: "Info notification",
      icon: "comment",
      color: "success",
      description:"Get more space"
    },
  }